export class DTO_Value {
    value: string;
    selected: boolean;
}